import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../app/hooks'
import { GetAllWorkoutsSecureAsync, selectAsc, selectEditFlag, selectSortBy, selectWorkouts, sortData } from '../features/add_workout/workoutSlice'
import { Link, Outlet } from 'react-router-dom'
import { changeDateFormat, tableDesign } from '../app/consts'
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from '@mui/material'
import ShowNotesModal from './ShowNotesModal'

const WorkoutsList = () => {
  const dispatch = useAppDispatch();
  const WorkoutsArr = useAppSelector(selectWorkouts)

  const editFlag = useAppSelector(selectEditFlag);
  const [SelectVisibility, setSelectVisibility] = useState<"future" | "past" | "all">("future");
  const [SelectActive, setSelectActive] = useState<"active" | "all">("active");
  const [hold, setHold] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    dispatch(GetAllWorkoutsSecureAsync({ dateParam: SelectVisibility, statusParam: SelectActive })).unwrap()
      .catch((err) => console.error("Handled error:", err))
      .then(() => {
        sortData({ by: 'date', type: "complete" });
        setHold(false);
      })
    // eslint-disable-next-line
  }, [editFlag, SelectVisibility, SelectActive])

  const sortBy = useAppSelector(selectSortBy);
  const asc = useAppSelector(selectAsc);

  return (
    <div style={{ margin: 'auto', textAlign: 'center' }} >
      <h1>ניהול אימונים</h1>
      <Button onClick={() =>
        setSelectVisibility("future")
      } variant={SelectVisibility === 'future' ? "contained" : "text"} color='inherit'>הצג אימונים עתידיים בלבד</Button>
      <Button onClick={() =>
        setSelectVisibility("past")
      } variant={SelectVisibility === 'past' ? "contained" : "text"} color='inherit'>הצג אימוני עבר בלבד</Button>
      <Button onClick={() =>
        setSelectVisibility("all")
      } variant={SelectVisibility === 'all' ? "contained" : "text"} color='inherit'>הצג את כל האימונים</Button>
      <br />
      <Button onClick={() =>
        setSelectActive("active")
      } variant={SelectActive === "active" ? "contained" : "text"} color='inherit'>הצג אימונים אימונים פעילים בלבד</Button>
      <Button onClick={() =>
        setSelectActive("all")
      } variant={SelectActive === "all" ? "contained" : "text"} color='inherit'>הצג את כל האימונים</Button>
      <br /><br />
      {hold ?
        <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        :
        <>
          {WorkoutsArr?.length > 0 ?
            <Paper sx={tableDesign}>
              <TableContainer sx={{ maxHeight: '60dvh' }}>
                <Table stickyHeader aria-label="sticky table" sx={{ "& .MuiTableCell-root": { fontSize: "1em", textAlign: 'center' } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <TableSortLabel
                          active={sortBy === 'date'}
                          direction={sortBy === 'date' ? (asc ? 'asc' : 'desc') : 'asc'}
                          onClick={() => dispatch(sortData({ by: 'date', type: "complete", asc: sortBy === 'date' ? !asc : true }))}>
                          תאריך ושעה
                        </TableSortLabel></TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={sortBy === 'type'}
                          direction={sortBy === 'type' ? (asc ? 'asc' : 'desc') : 'asc'}
                          onClick={() => dispatch(sortData({ by: 'type', type: "complete", asc: sortBy === 'type' ? !asc : true }))}>
                          סוג האימון
                        </TableSortLabel></TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={sortBy === 'instructor'}
                          direction={sortBy === 'instructor' ? (asc ? 'asc' : 'desc') : 'asc'}
                          onClick={() => dispatch(sortData({ by: 'instructor', type: "complete", asc: sortBy === 'instructor' ? !asc : true }))}>
                          מדריך
                        </TableSortLabel></TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={sortBy === 'location'}
                          direction={sortBy === 'location' ? (asc ? 'asc' : 'desc') : 'asc'}
                          onClick={() => dispatch(sortData({ by: 'location', type: "complete", asc: sortBy === 'location' ? !asc : true }))}>
                          מיקום
                        </TableSortLabel></TableCell>
                      <TableCell>
                        <TableSortLabel
                          active={sortBy === 'maximumParticipants'}
                          direction={sortBy === 'maximumParticipants' ? (asc ? 'asc' : 'desc') : 'asc'}
                          onClick={() => dispatch(sortData({ by: 'maximumParticipants', type: "complete", asc: sortBy === 'maximumParticipants' ? !asc : true }))}>
                          מספר משתתפים מקסימלי
                        </TableSortLabel></TableCell>
                      <TableCell>הערות לאימון</TableCell>
                      <TableCell>משתתפים</TableCell>
                      <TableCell>פעיל?</TableCell>
                      <TableCell>פעולות</TableCell>
                      <TableCell>שיתוף</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {WorkoutsArr?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((value: any, index: number) =>
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        {

                        }
                        <TableCell>{changeDateFormat(value.date)} - {(value.time as string).slice(0, -3)}</TableCell>
                        <TableCell>{value.type.name}</TableCell>
                        <TableCell>{value.instructor.fullName}</TableCell>
                        <TableCell>{value.location}</TableCell>
                        <TableCell>{value.maximumParticipants}</TableCell>
                        <TableCell>{value.notes === "" ? "-" : <ShowNotesModal data={value.notes} name={value.type.name} date={`${changeDateFormat(value.date)} - ${(value.time as string).slice(0, -3)}`} />}</TableCell>
                        <TableCell>{(value.participantsList?.length as number < value.maximumParticipants) ? value.participantsList?.length : "האימון מלא"}</TableCell>
                        <TableCell>{value.isActive ? "כן" : "לא"}</TableCell>
                        <TableCell>
                          {value.participantsList.length > 0 && <><Link to={`/manageWorkout/participants/${value.id}`} relative='path'>נהל משתתפים</Link><hr /></>}
                          <Link to={`/manageWorkout/edit/${value.id}`} relative='path'>ערוך אימון</Link>
                        </TableCell>
                        <TableCell>
                          <a href={`whatsapp://send?text= ${window.location.origin}/register/${value.id}`} target='_blank' rel="noreferrer"><img src='/whatsapp.png' alt='שתף באמצעות whatsapp' style={{ width: '20px' }} /></a>
                        </TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={WorkoutsArr.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ justifySelf: 'right', direction: 'ltr' }}
              />
            </Paper>
            :
            <h1>לא קיימים אימונים שמקיימים את התנאים</h1>}
          <Outlet />
        </>}
    </div >
  )
}

export default WorkoutsList